import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

class Anchor {
  constructor(selector, options) {
    this.selector = selector;
    this.elements = document.querySelectorAll(selector);
    this.params = {
      container: window,
      duration: 0.9,
      ...options,
    };
    this.#init();
  }
  #init() {
    this.#event();
  }
  #event() {
    const _this = this;
    const triggerAnchor = e => {
      const anchorEl = e.target.closest(_this.selector);
      const container = anchorEl.getAttribute('data-anchor-container') || _this.params.container;
      const duration = Number(anchorEl.getAttribute('data-anchor-duration') || _this.params.duration);
      const spacerEl = anchorEl.getAttribute('data-anchor-spacer') || _this.params.spacerEl;
      const spacerElH = spacerEl ? document.querySelector(spacerEl).getBoundingClientRect().height : 0;
      const target = anchorEl.getAttribute('data-anchor') || document.body;
      gsap.to(container, {
        scrollTo: {
          y: target,
          offsetY: spacerElH,
        },
        duration: duration,
        ease: 'power2.in',
      });
    };
    _this.elements.forEach(element => {
      element.addEventListener('click', triggerAnchor);
    });
  }
}

export default Anchor;
